import JabatanSelectorMain from "../../features/selector/jabatan-selector/components/jabatan-selector-main";

const JabatanSelectorDialog = (props) => {
  return <JabatanSelectorMain {...props} />;
};

export default JabatanSelectorDialog;
